import { supabase } from '../lib/supabase';
import { logError } from '../lib/logError';

export const getCargos = async ({ apenasAtivos = false } = {}) => {
    // leitura via anon (policy SELECT pública para ativo=true)
    let query = supabase.from('bd_cargos').select('*').order('nome').order('nivel');
    if (apenasAtivos) query = query.eq('ativo', true);
    const { data, error } = await query;
    if (error) { logError(error, { fn: 'getCargos' }); throw error; }
    return data;
};

export const salvarCargo = async (dadosCargo) => {
    const {
        acao, id, nome, slug_canonical,
        nivel,
        comissao_agendamento_tipo, comissao_agendamento_valor,
        comissao_venda_tipo, comissao_venda_valor,
        comissao_venda_override_valor,
        comissao_indicacao_tipo, comissao_indicacao_valor,
        comissao_contato_tipo, comissao_contato_valor,
        salario_base, meta_mensal, descricao,
        ativo,
    } = dadosCargo;

    const payload = {
        nome: (nome || '').trim(),
        slug_canonical: slug_canonical || (nome || '').trim().toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, ''),
        nivel: parseInt(nivel) || 1,
        comissao_agendamento_tipo: comissao_agendamento_tipo || 'fixed',
        comissao_agendamento_valor: parseFloat(comissao_agendamento_valor) || 0,
        comissao_venda_tipo: comissao_venda_tipo || 'percent',
        comissao_venda_valor: parseFloat(comissao_venda_valor) || 0,
        comissao_venda_override_valor: comissao_venda_override_valor === '' || comissao_venda_override_valor == null
            ? null
            : parseFloat(comissao_venda_override_valor) || 0,
        comissao_indicacao_tipo: comissao_indicacao_tipo || 'percent',
        comissao_indicacao_valor: parseFloat(comissao_indicacao_valor) || 0,
        comissao_contato_tipo: comissao_contato_tipo || 'fixed',
        comissao_contato_valor: parseFloat(comissao_contato_valor) || 0,
        salario_base: salario_base !== '' && salario_base != null ? parseFloat(salario_base) : null,
        meta_mensal: meta_mensal !== '' && meta_mensal != null ? parseFloat(meta_mensal) : null,
        descricao: descricao || null,
        ativo: ativo !== false,
    };

    // escrita via cliente autenticado (sessão do usuário) + RLS que permite write a autenticados
    if (acao === 'excluir') {
        const { error } = await supabase.from('bd_cargos').delete().eq('id', id);
        if (error) { logError(error, { fn: 'salvarCargo/excluir', id }); throw error; }
        return { success: true };
    }

    if (acao === 'editar') {
        const { error } = await supabase.from('bd_cargos').update(payload).eq('id', id);
        if (error) { logError(error, { fn: 'salvarCargo/editar', id }); throw error; }
        return { success: true };
    }

    const { error } = await supabase.from('bd_cargos').insert(payload);
    if (error) { logError(error, { fn: 'salvarCargo/inserir' }); throw error; }
    return { success: true };
};

export const toggleCargo = async (id, ativo) => {
    const { error } = await supabase.from('bd_cargos').update({ ativo }).eq('id', id);
    if (error) { logError(error, { fn: 'toggleCargo', id }); throw error; }
    return { success: true };
};
